module.exports = "/assets/2e8a2fd30187e5f0847f1d4272bbf057.png";


//////////////////
// WEBPACK FOOTER
// ./src/app/modules/flights/assets/logos-small/L9.png
// module id = 2695
// module chunks = 0